import { skeletonStyles } from './styles'
import { mtc } from '../../../utils/style-helpers'
import { HTMLAttributes } from 'react'

function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={mtc(skeletonStyles(), className)} {...props} />
}
export { Skeleton }
